import { Record } from 'immutable';
const Sender = Record({
  avatar: null,
  email: null,
  firstName: null,
  id: null,
  lastName: null,
  senderType: null
}, 'Sender');
export default Sender;